import TwoColumnTextImage from './twoColumnTextImage';

function TwoColValueProps(props) {
  const roundedImage = 'roundedImage'; // set rounded image box for twoColValueProps
  return <TwoColumnTextImage {...props} roundedImage={roundedImage} />;
}
export default TwoColValueProps;
